<!-- 添加访客接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: { "parkCode":"2KNTYVWC","carCode":"粤YGW982","owner":"李四","visitName":"1","phonenum":"13596156884","reason":"访友","visitTime":"20161214163930-20161215163930"},
            responseCode: 	{
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台添加某个访客车辆",
                t_url: this.commonUrls.test+"addVisitorCar",
                p_url: this.commonUrls.prod+"addVisitorCar",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌' },
                        { info1: 'owner', info2: '是', info3: 'String', info4: '车主' },
                        { info1: 'visitName', info2: '是', info3: 'String', info4: 'VIP类型的名称（访客类型的VIP，在vems--车主管理--VIP类型--筛选访客--选择具有该车场通道权限的访客类型中的VIP名称。注意：在一个vems配置多个车场的情况下，每个车场的访客类型一定只能关联对应车场的通道，否则可能造成下发访客时，不同车场的访客时段重叠而不能下发问题）' },
                        { info1: 'phonenum', info2: '是', info3: 'String', info4: '电话号码' },
                        { info1: 'reason', info2: '否', info3: 'String', info4: '来访原因' },
                        { info1: 'visitTime', info2: '否', info3: 'String', info4: '预计来访时间，格式为：起始时间-结束时间yyyyMMddHHmmss-yyyyMMddHHmmss' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/vip/addVisitorCar.vue